export default __webpack_public_path__ + "static/media/mathAI.376e43a8.webp";